import styled from 'styled-components'
import { breakpoint, Required, H4Styles } from '../../layout/mixins'

export const Heading = styled.h4`
  ${H4Styles}
  background: ${({ theme }) => theme.themeColorLight};
  padding: ${({ theme }) => theme.gutter} 10px;
  margin: 0;
  font-weight: 500;
  ${breakpoint.up('tablet')`
    display: none;
  `}
`

export const StyledRequired = styled(Required)`
  top: 1.1em;
  z-index: 10;
`

export const Container = styled.article`
  position: relative;
`

export const Table = styled.table`
  width: 100%;
  margin: ${({ theme }) => theme.gutter} 0;

  ${breakpoint.up('tablet')`
    margin-top: ${({ theme }) => theme.gutterMedium};
  `}
`

export const THead = styled.thead`
  background: ${({ theme }) => theme.themeColorLight};

  ${breakpoint.down('tablet')`
    display: none;
  `}
`
export const TBody = styled.tbody`
 
`

export const TH = styled.th`
  text-align: left;
  padding: ${({ theme }) => theme.gutter} 10px;
  font-weight: 500;

  ${breakpoint.up('tablet')`
    &:nth-child(1) {
      width: 45%;
    }
    &:nth-child(2) {
      width: 45%;
    }
    &:nth-child(3) {
      width: 10%;
    }

    &:last-child {
      padding-right: 25px;
    }
  `}
`

export const TD = styled.td`
  text-align: left;
  padding: 15px 10px;

  ${breakpoint.down('tablet')`
    display: block;
    padding-left: 50%;
    position: relative;
    border-bottom: 1px solid rgba(0,0,0,0.04);


    &:nth-child(2) {
      padding-left: 10px;
      padding-top: 50px;
    }

    &:before {
      content: attr(data-title);
      display: block;
      position: absolute;
      left: 10px;
      top: 15px;
      font-weight: 500;
    }
  `}
`

export const TR = styled.tr`

  ${breakpoint.down('tablet')`
    &:nth-child(even) {
      background: rgba(255,255,255,0.4);
    }
  `}

  ${breakpoint.up('tablet')`
    cursor: pointer;
    &:hover {
      background: rgba(255,255,255,0.3);
    }

    border-bottom: 1px solid rgba(0,0,0,0.1);

    ${TD}:last-child,
    ${TH}:last-child {
      text-align: center;
      vertical-align: middle;
    }
  `}
`
